import dayjs from 'dayjs';
import { DateRange } from 'react-day-picker';

interface SummaryTimePoint {
  date?: string;
  day?: string;
  hour?: string;
}

const MAX_VISIBLE_DATE_TICKS = 7;

export const formatCloudEventsSummaryTime = (point: SummaryTimePoint) => {
  const value = point.hour ?? point.day ?? point.date;
  if (!value) return '-';

  const parsedValue = dayjs.utc(value).local();
  if (!parsedValue.isValid()) return String(value);

  return point.hour
    ? parsedValue.format('H:mm:ss')
    : parsedValue.format('D-MMM');
};

export const getCloudEventsSummaryXAxisInterval = (
  isHourly: boolean | undefined,
  pointCount: number,
) => {
  if (isHourly) return pointCount > 8 ? 1 : 0;
  if (pointCount <= MAX_VISIBLE_DATE_TICKS) return 0;

  return Math.ceil(pointCount / MAX_VISIBLE_DATE_TICKS) - 1;
};

export const formatCloudEventsSummaryDateRange = (range: DateRange) => {
  if (!range.from || !range.to) return undefined;

  const from = dayjs(range.from);
  const to = dayjs(range.to);
  const formattedFrom = from.format('MMM D, YYYY');

  if (from.isSame(to, 'day')) return formattedFrom;

  return `${formattedFrom} - ${to.format('MMM D, YYYY')}`;
};
